import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import "./header.css"

const Header = ({ brandName }) => (
  <header className="site-header">
    <div className="centered-content header-content">
      <h1>
        <Link to="/" className="site-branding">
          {brandName}
        </Link>
      </h1>
      <p className="site-slogan">
        Share memories, <span className="wrap">not money problems.</span>
      </p>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
